export default __webpack_public_path__ + "app/modules/linshare.secondFactorAuthentication/images/google-play.svg";